const PRODUCTION_HOSTS = new Set([
  'horapilot.com',
  'www.horapilot.com',
  'cih.horapilot.com',
]);

export const isCihHost = () => (
  typeof window !== 'undefined' && window.location.hostname === 'cih.horapilot.com'
);

export const getAdminHomePath = () => (isCihHost() ? '/' : '/super-admin');

export const getApiBaseUrl = () => {
  if (typeof window !== 'undefined' && PRODUCTION_HOSTS.has(window.location.hostname)) {
    return window.location.origin;
  }

  return process.env.REACT_APP_API_URL || 'http://localhost:5001';
};

export const API_URL = getApiBaseUrl();
